import initState from "./initState";

export default {
  SET_TOKEN(state, payload) {
    state.token = payload;
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_REGISTER(state, payload) {
    state.register = payload;
  },
  SET_INSTRUCTORS_LIST(state, payload) {
    state.instructorsList = payload;
  },
  SET_COURSE_LIST(state, payload) {
    state.courseList = payload;
  },
  SET_TOPIC_LATEST(state, payload) {
    state.topicLatest = payload;
  },
  SET_HAVE_USER_DATA(state, payload) {
    state.haveUserData = payload;
  },
  SIGNOUT: (state) => {
    const initial = initState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};
